<template>
  <div class="flex_ correct-title">
    <span class="icon_"></span>
    <span class="text_">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'correctTitle',
  props: {
    title: {
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.correct-title {
  margin-bottom: 14px;
  .icon_ {
    width: 2px;
    height: 13px;
    display: block;
    background: #ff3600;
    border-radius: 1px;
    margin-right: 9px;
  }
  .text_ {
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: bold;
    color: #121212;
    line-height: 17px;
  }
}
.mobile_ {
  .correct-title {
    margin-bottom: 18px;
    margin-left: -5px;
    .icon_ {
      width: 5px;
      height: 12px;
      display: block;
      background: #ff3600;
      border-radius: 3px;
      margin-right: 9px;
    }
    .text_ {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #090909;
      line-height: 23px;
    }
  }
}
</style>
